<template> <!-- 休日コンポーネント(子) -->
  <div class="roster-cell roster-cell--holiday-work">
    <p class="roster-cell__value">
      <span>{{ holidayResult[index] }}</span>
    </p>
  </div>
</template>

<script>
import moment from 'moment'
import ConstList from './../ConstList'
export default {
  name: 'HolidayWork',
  props: {
    monthDay: Array,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    index: Number
  },
  computed: {
    /*
     * 休日作業も「値を返す」だけにする。
     *
     * 以前は null を返す computed が data の配列を splice で書き換え、
     * それを deep watch が拾って親へ渡していた。computed は読まれたとき
     * にしか動かないので、親へ届く時機が描画の順番まかせになる。控除
     * （Deduction.vue）で同じ作りが実害を出した。月次集計の休日作業時間も
     * 画面が送ってきた合計をそのまま保存するため、同じ壊れ方をする。
     *
     * 時間外（OverTime.vue）と同じ形へそろえた。
     */
    holidayResult () {
      return (this.start || []).map((_, i) => this.holidayWorkAt(i))
    }
  },
  watch: {
    /*
     * 値が変わったら必ず親へ渡す。**emit は $nextTick へ回すこと。**
     * 親は受け取った値を $set で書き戻すので、描画の最中に同期で emit すると
     * 子を patch している途中で親の更新が走り、落ちる（控除側で実測）。
     */
    holidayResult: {
      immediate: true,
      deep: true,
      handler (values) {
        const value = values[this.index]
        this.$nextTick(() => {
          this.$emit('updateHolidayWork', {
            index: this.index,
            value
          })
        })
      }
    }
  },
  methods: {
    /*
     * 1日ぶんの休日作業時間を出す。**計算そのものは変えていない。**
     * 直したのは「いつ親へ渡すか」だけ。
     */
    holidayWorkAt (i) {
      const day = this.monthDay
      const sStr = this.start[i]
      const eStr = this.end[i]

      // 開始・終了どちらかが未入力なら null
      if (!sStr || !eStr) {
        return null
      }

      const sTime = moment.duration(sStr, 'HH:mm')
      const eTime = moment.duration(eStr, 'HH:mm')
      const bTime = moment.duration(this.rest[i], 'HH:mm')
      const diff = eTime.clone().subtract(sTime).subtract(bTime)

      if (this.attendance1[i] === ConstList.HOLIDAY
        && (day[i].substring(day[i].lastIndexOf("(") + 1, day[i].lastIndexOf(")")) === "日")
      ) {
        const hours = diff.hours() < 10 ? '0' + diff.hours() : diff.hours()
        const minutes = diff.minutes() < 10 ? '0' + diff.minutes() : diff.minutes()
        const time = hours + ':' + minutes
        return time == "00:00" ? null : time
      }
      return null
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
